import type { GridRenderCellParams } from "@mui/x-data-grid";

import Text from "../atoms/Text";

const DataGridTextCell = (params: GridRenderCellParams) => {
  return <Text variant="body_small">{params.value}</Text>;
};

export default DataGridTextCell;
